import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { getProductNameTextFromApiName } from '../../_core/common/adapters/getProductNameText';
import { track } from '../../_core/common/eventTracking/tracker';
import getUpgradeBannerTranslations from '../../_core/utils/getUpgradeBannerTranslations';
import { getUpgradeDataFromUpgradeConfig } from '../../_core/utils/getUpgradeDataFromUpgradeConfig';
import UIContactSalesButton from '../../button/UIContactSalesButton';
import { getBannerI18nSubTitleKey, getBannerI18nTitleKey, getUpgradeConfigTrackingProperties, updateViewedUpgradePointsCache } from '../utils';
import DefaultBanner from './DefaultBanner';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const LimitPackBannerTitle = ({
  featureTranslationKey,
  value,
  limit,
  title
}) => {
  if (title) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: title
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nTitleKey('upgrades.limitPackBanner.header', featureTranslationKey),
    options: {
      value,
      limit
    }
  });
};
export const LimitPackBannerSubtext = ({
  apiName,
  featureTranslationKey,
  subtitle
}) => {
  if (subtitle) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: subtitle
    });
  }
  const translatedProductName = getProductNameTextFromApiName(apiName);
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getBannerI18nSubTitleKey('upgrades.limitPackBanner.subtext', featureTranslationKey),
    options: {
      productName: translatedProductName
    }
  });
};
const LimitPackBanner = ({
  upgradePoint,
  limit,
  value,
  displayThreshold,
  marginStyle,
  'data-test-id': dataTestId = 'limit-pack-banner',
  displayBannerOverride = false
}) => {
  const upgradeData = getUpgradeDataFromUpgradeConfig(upgradePoint);
  useEffect(() => {
    updateViewedUpgradePointsCache(upgradePoint.upgradeKey, () => {
      const limitInteractionTrackingData = {
        limit,
        value,
        displayThreshold,
        hasReachedLimit: value >= limit
      };
      track('interaction', Object.assign({
        action: 'viewed upgrade point'
      }, limitInteractionTrackingData, getUpgradeConfigTrackingProperties(upgradePoint)));
    });
  }, [upgradePoint, limit, value, displayThreshold]);
  if (!displayBannerOverride && displayThreshold && value < displayThreshold) {
    return null;
  }
  const {
    bannerTitle,
    bannerSubtitle
  } = getUpgradeBannerTranslations(upgradePoint.descriptions);
  return /*#__PURE__*/_jsx(DefaultBanner, {
    titleText: /*#__PURE__*/_jsx(LimitPackBannerTitle, {
      featureTranslationKey: upgradePoint.featureTranslationKey,
      value: value,
      limit: limit,
      title: bannerTitle
    }),
    marginStyle: marginStyle,
    dataTestId: dataTestId,
    subtext: /*#__PURE__*/_jsx(LimitPackBannerSubtext, {
      apiName: upgradeData.apiName,
      featureTranslationKey: upgradePoint.featureTranslationKey,
      subtitle: bannerSubtitle
    }),
    button: /*#__PURE__*/_jsx(UIContactSalesButton, {
      apiName: upgradeData.apiName,
      upgradeData: upgradeData,
      use: "link",
      isUpgradePoint: true
    })
  });
};
export default LimitPackBanner;